<template>
  <div no-gutters class="d-print-none" align="right">
    <v-btn
      v-for="opt in langsPath"
      :key="opt.lang"
       elevation="0"
      color="transparent"
      class="ml-2 link--text"
      :to="{path: opt.path}"
    >
      {{LANGS[opt.lang]}}
      <v-icon right>
        mdi-arrow-right
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
  import dbs_simplified from '../data/dbs_simplified'
  export default {
    name: 'DbLangOpts',
    props: {
      abbr: String,
      curLang: String
    },
    data(){
      return {
        LANGS: {en: 'English', tc: '繁體中文', sc: '简体中文'},
        LANGSLIST: ['en', 'tc', 'sc']
      }
    },
    computed: {
      langsPath(){
        return dbs_simplified.filter(
          db => db.lang !== this.curLang && db.abbr == this.abbr
        ).map(
          db => {return {lang: db.lang.toLowerCase(), path: db.path}}
        ).sort((a, b) => this.LANGSLIST.indexOf(a.lang) - this.LANGSLIST.indexOf(b.lang))
      }
    },
    
  }
</script>